// Identifiers: ULIDs for records, short tokens for the WhatsApp prefill. No dependencies.
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
// Token alphabet: Crockford base32 minus the vowels A and E (I, O, U are already excluded).
const TOKEN_ALPHABET = '0123456789BCDFGHJKMNPQRSTVWXYZ';

export function ulid(now: number = Date.now()): string {
  let time = now;
  let t = '';
  for (let i = 0; i < 10; i++) {
    t = CROCKFORD[time % 32] + t;
    time = Math.floor(time / 32);
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let r = '';
  for (const b of bytes) r += CROCKFORD[b % 32];
  return t + r;
}

export function ticketToken(): string {
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  let s = '';
  for (const b of bytes) s += TOKEN_ALPHABET[b % TOKEN_ALPHABET.length];
  return s;
}

/** A token as it appears inside a message: six token characters delimited by non-alphanumerics. */
export const TOKEN_REGEX = /(?<![0-9A-Z])([0-9BCDFGHJKMNPQRSTVWXYZ]{6})(?![0-9A-Z])/;

export function isTicketToken(s: string): boolean {
  return /^[0-9BCDFGHJKMNPQRSTVWXYZ]{6}$/.test(s);
}

export function randomKey(prefix: string, bytes = 24): string {
  const b = new Uint8Array(bytes);
  crypto.getRandomValues(b);
  let s = '';
  for (const x of b) s += CROCKFORD[x % 32];
  return `${prefix}_${s}`;
}
